module.exports = !!(typeof process != 'undefined' && process.versions && process.versions.node);
